import api from '@/api/api'

const state = {
  data: {},
  name: '',
}

const mutations = {
  GET_DOCUMENT: (state, data) => {
    state.data = data.data
    state.name = data.name
  },

  CLEAR_DOCUMENT: state => {
    state.data = {}
    state.name = ''
  },
}

const actions = {
  clearDocument: ({ commit }) => {
    return new Promise(resolve => {
      commit('CLEAR_DOCUMENT')
      resolve()
    })
  },

  postDocument: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      api
        .postDocument(data)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  getDocument: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .getDocument(id)
        .then(response => {
          commit('GET_DOCUMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  patchDocument: ({ commit }, patchData) => {
    const { id, data } = patchData
    return new Promise((resolve, reject) => {
      api
        .patchDocument(id, data)
        .then(response => {
          commit('GET_DOCUMENT', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },

  deleteDocument: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      api
        .deleteDocument(id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
          console.error(err)
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
